import { BaseFactory } from './BaseFactory';
import { Handler as Stores } from '../Handlers/Stores/Handler';

export class Handlers extends BaseFactory
{
	protected _stores=null;
	
	public handle(reqObj)
	{
		try {
			
			if (reqObj.getL1() === "Stores") {
				this.getStores().handle(reqObj);
			} else {
				this.getStores().routeInvalid(reqObj);
			}

		} catch (e) {
			reqObj.setException(e).send();
			this.callException(e);
			
		}
	}
	public getStores()
	{
		if (this._stores === null) {
			this._stores	= new Stores();
			this._stores.setService(this.getService());
			this._stores.setExceptionCb(this.getService().getLogging(), "exception");
		}
		return this._stores;
	}
}